var _ = require('underscore');
var Marionette = require("marionette");
var Behaviors = require('Behaviors');
var Dropdown = require("Dropdown");
var EdwClientEngagementSearch = require('EdwClientEngagementSearch');
var Entities = require('Entities');
var Labels = EY.Consultation.Labels;
var RecordCustomFields = require("RecordCustomField");
var Validation = require('validation');

var Layout = Marionette.View.extend({
    initialize: function () {
        Validation.bind(this);  
    },
    behaviors: [Behaviors.PrintCheckbox, Behaviors.MobileView],
    events: {
        'blur @ui.clientId': function () { this.model.set('clientId', this.ui.clientId.val()); },
        'blur @ui.clientName': function () { this.model.set('clientName', this.ui.clientName.val()); },
        'blur @ui.engagementId': function () { this.model.set('engagementId', this.ui.engagementId.val()); },
        'blur @ui.engagementName': function () { this.model.set('engagementName', this.ui.engagementName.val()); },
        'click @ui.auditClient': function (e) { this.model.set('auditClient', e.target.checked); },
        'click @ui.closeMonitoring': function (e) { this.model.set('closeMonitoring', e.target.checked); },
        'click @ui.listedEntity': function (e) { this.model.set('listedEntity', e.target.checked); },
        'click @ui.manualCheck': 'toggleView',
        'click @ui.nonListedPie': function (e) { this.model.set('nonListedPie', e.target.checked); },
        'click @ui.secRegistrant': function (e) { this.model.set('secRegistrant', e.target.checked); },
        'click @ui.auditClientQuestion': function (e) {e.preventDefault(); },
        'click @ui.closeMonitoringQuestion': function (e) {e.preventDefault(); },
        'click @ui.listedEntityQuestion': function (e) {e.preventDefault(); },
        'click @ui.nonListedPieQuestion': function (e) {e.preventDefault(); },
        'click @ui.secRegistrantQuestion': function (e) {e.preventDefault(); },
        'click @ui.engagementSearch':'showEngagementSearch'
    },
    regions: {
        accountingStandard: '#accountingStandard',
        clientId: '#clientId',
        clientName: '#clientName',
        engagementCode: '#engagementCode',
        engagementName: '#engagementName',
        fields: '#fields',
        industry: "#industry"
    },
    template: "#recordClientEngagementLayout",
    ui: {
        auditClient: '#auditClient',
        auditClientQuestion:'#auditClientQuestion',
        clientId: '#clientId',
        clientName: '#clientName',
        closeMonitoring: '#closeMonitoring',
        closeMonitoringQuestion:'#closeMonitoringQuestion',
        closeMonitoringContainer: '#closeMonitoringContainer',
        engagementId:'#engagementId',
        engagementName: '#engagementName',
        engagementSearch:'#engagementSearch',
        fiscalYearEnd: '#fiscalYearEnd',
        prfiscalYearEnd: '#prfiscalYearEnd',
        listedEntity: '#listedEntity',
        listedEntityQuestion:'#listedEntityQuestion',
        listedEntityContainer: '#listedEntityContainer',
        manualCheck: '#manualCheck',
        manualInfo: '#manualInfo',
        nonListedPie: '#nonListedPie',
        nonListedPieQuestion:'#nonListedPieQuestion',
        nonListedPieContainer: '#nonListedPieContainer',
        primaryAccountingStandardsContainer:"#primaryAccountingStandardsContainer",
        secRegistrant: "#secRegistrant",
        secRegistrantQuestion:'#secRegistrantQuestion',
        secRegistrantContainer: '#secRegistrantContainer'

    },
    onRender: function () {
        var configuration = this.model.get('configuration');
        var context = this;

        this.ui.auditClient.attr("checked", this.model.get('auditClient'));
        this.ui.fiscalYearEnd.val(this.model.get('fiscalYearEnd') ? new Date(this.model.get('fiscalYearEnd')).format() : '');
        this.ui.prfiscalYearEnd.html(this.model.get('fiscalYearEnd') ? new Date(this.model.get('fiscalYearEnd')).format() : '');
        this.ui.fiscalYearEnd.datepicker({
            todayHighlight: true,
            format: 'dd MM yyyy',
            autoclose: true
        }).on('changeDate', function (e) {
            context.model.set('fiscalYearEnd', e.date);
            });
        if (this.model.get('validateEngagement')) {
            this.ui.clientId.attr('disabled', 'disabled').addClass('disabled');
            this.ui.clientName.attr('disabled', 'disabled').addClass('disabled');
            this.ui.engagementName.attr('disabled', 'disabled').addClass('disabled');
        } else {
            this.ui.manualInfo.removeClass('hidden');
            this.ui.manualCheck.attr('checked', 'checked');
        }
        if (configuration.DisplaySEC) {
            this.ui.secRegistrantContainer.removeClass('hidden');
            this.ui.secRegistrant.attr("checked", this.model.get('secRegistrant'));
        }
        if (configuration.DisplayListedEntity) {
            this.ui.listedEntityContainer.removeClass('hidden');
            this.ui.listedEntity.attr("checked", this.model.get('listedEntity'));
        }
        if (configuration.DisplayNonListedPIE) {
            this.ui.nonListedPieContainer.removeClass('hidden');
            this.ui.closeMonitoringContainer.addClass('col-md-offset-1');
            this.ui.nonListedPie.attr("checked", this.model.get('nonListedPie'));
        }
        if (configuration.DisplayCloseMonitoring) {
            this.ui.closeMonitoringContainer.removeClass('hidden');
            this.ui.closeMonitoring.attr("checked", this.model.get("closeMonitoring"));
        }
        if (!this.model.id || this.model.get('displayAccountingstandard')) {
            this.model.set('displayAccountingstandard', true);
            this.ui.primaryAccountingStandardsContainer.removeClass('hidden');
            Dropdown.show({
                collection: new Backbone.Collection(_.filter(EY.Consultation.Resources.Enumeration, { type: 'PrimaryAccountingStandardType' })),
                region: this.getRegion('accountingStandard'),
                selection: this.model.get('accountingStandard'),
                tooltip: true,
                resourceKeyAttribute: "id",
                onSelectionChanged: function (accountingStandard) {
                    context.model.set('accountingStandard', accountingStandard.id);
                }
            });

            this.model.validation = _.extend(this.model.validation, {
                accountingStandard: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.PrimaryAccountingStandard_ErrorMSG) }
            });
        } else {
            delete this.model.validation.accountingStandard;
        }
        Dropdown.show({
            collection: new Backbone.Collection(EY.Consultation.Resources.Industry, { comparator: "name" }),
            region: this.getRegion('industry'),
            resourceKeyAffix: "Industry_",
            resourceKeyAttribute: "id",
            selection: this.model.get('industryId'),
            textAttribute: "name",
            tooltip: true,
            onSelectionChanged: function (industry) {
                context.model.set('industryId', industry.id);
            }
        });

        Behaviors.tooltip(this.$el.find("#engagementIcon"));

        if (!this.model.get('validateEngagement')) {
            this.ui.engagementSearch.attr('disabled', 'disabled').addClass('disabled');
        }
    },
    toggleView: function (e) {
        if (e && e.target.checked) {
            this.ui.clientId.removeAttr('disabled').removeClass('disabled');
            this.ui.clientName.removeAttr('disabled').removeClass('disabled');
            this.ui.engagementName.removeAttr('disabled').removeClass('disabled');
            this.ui.engagementId.removeAttr('disabled').removeClass('disabled');
            this.ui.engagementSearch.attr('disabled', 'disabled').addClass('disabled');
            this.model.set('validateEngagement', false);
        } else {
            this.ui.clientId.attr('disabled', 'disabled').addClass('disabled').val('').blur();
            this.ui.clientName.attr('disabled', 'disabled').addClass('disabled').val('').blur();
            this.ui.engagementName.attr('disabled', 'disabled').addClass('disabled').val('').blur();            
            this.ui.engagementId.attr('disabled', 'disabled').addClass('disabled').val('').blur(); 
            this.ui.engagementSearch.removeAttr('disabled').removeClass('disabled');
            this.model.set('validateEngagement', true);
        }
    },
    showEngagementSearch:function(){
        var context = this;
        EdwClientEngagementSearch.show({
            collection:new Entities.Engagements(),
            record:context.model,
            onSelectionChanged: function () {
                context.ui.engagementId.val(context.model.get('engagementId'));
                context.ui.engagementName.val(context.model.get('engagementName'));
                context.ui.clientName.val(context.model.get('clientName'));
                context.ui.clientId.val(context.model.get('clientId'));
                context.$el.find('#industry select').prop('selectedIndex', context.model.get('industryId'))
            }
        });
    }
});

module.exports.start = function (options) {
    var record = options.record,
        region = options.region,
        layout = new Layout({
            model: record
        });

    region.show(layout);

    RecordCustomFields.start(_.extend({}, options, {
        region: layout.getRegion('fields')
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordClientEngagement.js